import CompanyOvertimeEditComponent from "../components/CompanyOvertimeEdit";
import useCompanyOvertime from "../hooks/useCompanyOvertime";

const CompanyOvertimeEdit = (props) => {
  const useCompanyOvertimeProps = useCompanyOvertime(props);
  return <CompanyOvertimeEditComponent {...useCompanyOvertimeProps} />;
};

export default CompanyOvertimeEdit;
